// extracted by mini-css-extract-plugin
module.exports = {"quantityFilterMenuBody":"styles_quantityFilterMenuBody__2eb1i","isChanged":"styles_isChanged__37uqs"};